import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const SEO = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const enLdJsonProducts = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'Motor Insurance',
        brand: { '@type': 'Organization', name: 'Tameeni' },
        description:
          'Compare between 20+ insurance providers, select & buy the best motor insurance options that fit your needs. Insure your car online.',
        category: 'Motor Insurance',
        url: 'https://www.tameeni.com/en',
      },
      {
        '@type': 'Product',
        name: 'Medical Malpractice Insurance',
        brand: { '@type': 'Organization', name: 'Tameeni' },
        description:
          'The best solutions for medical malpractice insurance in Saudi Arabia. Explore tailored coverage options to meet your needs.',
        category: 'Medical Malpractice Insurance',
        url: 'https://www.tameeni.com/en/mmp',
      },
      {
        '@type': 'Product',
        name: 'SME Health Insurance',
        brand: { '@type': 'Organization', name: 'Tameeni' },
        description:
          'Within minutes, compare and get instant medical and health insurance for small and medium enterprises. Various benefits and many hospitals.',
        category: 'Health Insurance',
        url: 'https://www.tameeni.com/en/health-sme',
      },
      {
        '@type': 'Product',
        name: 'Travel Insurance',
        brand: { '@type': 'Organization', name: 'Tameeni' },
        description:
          'Compare travel insurance plans from top providers and find the best coverage at competitive rates on Tameeni. Get quotes in seconds and travel with peace of mind.',
        category: 'Travel Insurance',
        url: 'https://www.tameeni.com/en/travel',
      },
      {
        '@type': 'Product',
        name: 'Domestic Helper Insurance',
        brand: { '@type': 'Organization', name: 'Tameeni' },
        description:
          'Compare domestic helper insurance offers from leading companies in KSA and get the best prices to protect your helpers. Buy now.',
        category: 'Domestic Helper Insurance',
        url: 'https://www.tameeni.com/en/health',
      },
    ],
  };

  const arLdJsonProducts = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'تأمين المركبات',
        brand: { '@type': 'Organization', name: 'تأميني' },
        description:
          'قارن بين أكثر من ٢٠ شركة تأمين من مكان واحد واحصل على خيارت تأمين  للسيارات في أقل من دقيقة ، أمن سيارتك الآن',
        category: 'تأمين المركبات',
        url: 'https://www.tameeni.com/ar',
      },
      {
        '@type': 'Product',
        name: 'تأمين الأخطاء الطبية',
        brand: { '@type': 'Organization', name: 'تأميني' },
        description:
          'احصل على أفضل عروض التأمين لحماية الممارسين الطبيين والمؤسسات الصحية. اكتشف خيارات التغطية المخصصة لتلبية احتياجاتك. أمن الآن',
        category: 'تأمين ضد الأخطاء الطبية',
        url: 'https://www.tameeni.com/mmp',
      },
      {
        '@type': 'Product',
        name: 'التأمين الصحي للمؤسسات الصغيرة والمتوسطة',
        brand: { '@type': 'Organization', name: 'تأميني' },
        description:
          'خلال دقائق قارن واحصل على وثيقة فورية للتأمين الطبي والصحي للمنشآت الصغيرة والمتوسطة لكثير من شركات التأمين المعتمدة في المملكة. منافع وشبكات مستشفيات متنوعة.',
        category: 'تأمين صحي',
        url: 'https://www.tameeni.com/ar/health-sme',
      },
      {
        '@type': 'Product',
        name: 'تأمين العمالة المنزلية',
        brand: { '@type': 'Organization', name: 'تأميني' },
        description:
          'قارن بين عروض تأمين العمالة المنزلية في السعودية بسرعة وسهولة واحصل على الحماية المثالية بأفضل الاسعار. اشتر الآن.',
        category: 'تأمين العمالة المنزلية',
        url: 'https://www.tameeni.com/health',
      },
      {
        '@type': 'Product',
        name: 'تأمين السفر',
        brand: { '@type': 'Organization', name: 'تأميني' },
        description:
          'قارن خطط التأمين على السفر من أفضل الشركات واحصل على تغطية شاملة بأسعار تنافسية مع تأميني. احصل على عروض الأسعار في ثوانٍ واستمتع برحلتك بطمأنينة.',
        category: 'تأمين سفر',
        url: 'https://www.tameeni.com/travel',
      },
    ],
  };
  const arLdJsonPt1Of3 = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'تأميني',
    legalName: 'تأميني',
    url: 'https://www.tameeni.com',
    logo: 'https://www.tameeni.com/Resources/images/header-logo.svg',
    foundingDate: '2016',
    founders: [
      {
        '@type': 'Person',
        name: 'سليمان عبدالله الفلاج',
      },
      {
        '@type': 'Person',
        name: 'ثامر عبدالله الفلاج',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '7933 المهندس مساعد العنقري',
      addressLocality: 'السليمانية',
      addressRegion: 'RUH',
      postalCode: '12245',
      addressCountry: 'KSA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'خدمة العملاء',
      telephone: '[8002444455]',
      email: 'support@tameeni.com',
    },
    sameAs: [
      'https://www.instagram.com/tameeniksa',
      'https://twitter.com/TameeniKSA',
      'https://www.snapchat.com/add/tameeniksa',
      'https://www.facebook.com/Tameeniksa/',
      'https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/',
      'https://www.linkedin.com/company/tameeniksa/',
    ],
  };
  const arLdJsonPt2Of3 = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'ما هو الفرق بين تأمين ضد الغير (طرف ثالث) والتأمين الشامل؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يوفر تأمين ضد الغير (طرف ثالث) تغطية المسؤولية تجاه الغير فقط، وذلك حسب الشروط والاستثناءات الموضحة في وثيقة التأمين.علماً أن هذا التأمين يعد تأميناً إلزامياً حسب أنظمة المملكة العربية السعودية . التأمين الشامل : يوفر التأمين الشامل تغطية شاملة للمركبة المؤمن عليها وكذلك تغطية المسؤولية تجاه الغير. كما يشمل التأمين الشامل عادةً الخسارة أو الضرر للمركبة المؤمن عليها من الحوادث والحريق والسرقة، وذلك حسب الشروط والاستثناءات الموضحة في وثيقة التأمين',
        },
      },
      {
        '@type': 'Question',
        name: 'ماهي الوثيقة الموحدة للتأمين الإلزامي على المركبات؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'الوثيقة الموحدة للتأمين الإلزامي على المركبات هي وثيقة تحتوي على القواعد العامة والشروط للتأمين .والتي أصدرتها مؤسسة النقد العربي السعودي. ',
        },
      },
      {
        '@type': 'Question',
        name: 'هل موقع تأميني معتمد ومصرّح من الجهات الرسمية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، موقع تأميني هو أول موقع إلكتروني لشراء وثائق التأمين تم ترخصيه من مؤسسة النقد العربي السعودي.',
        },
      },
    ],
  };
  const enLdJsonPt1Of3 = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Tameeni',
    legalName: 'Tameeni',
    url: 'https://www.tameeni.com/en',
    logo: 'https://www.tameeni.com/Resources/images/header-logo.svg',
    foundingDate: '2016',
    founders: [
      {
        '@type': 'Person',
        name: 'Suliman Alfallaj',
      },
      {
        '@type': 'Person',
        name: 'Thamer Alfallaj',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '7933 Al Muhandis Masaid Al Anqari',
      addressLocality: 'As Sulimaniyah',
      addressRegion: 'RUH',
      postalCode: '12245',
      addressCountry: 'KSA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer care',
      telephone: '[8002444455]',
      email: 'support@tameeni.com',
    },
    sameAs: [
      'https://www.instagram.com/tameeniksa',
      'https://twitter.com/TameeniKSA',
      'https://www.snapchat.com/add/tameeniksa',
      'https://www.facebook.com/Tameeniksa/',
      'https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/',
      'https://www.linkedin.com/company/tameeniksa/',
    ],
  };
  const enLdJsonPt2Of3 = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is the unified policy for compulsory vehicle Insurance?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The Unified Policy for Compulsory Vehicle Insurance is a document containing general rules and conditions for insurance issued by the Saudi Arabian Monetary Agency.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the difference between third party insurance and comprehensive insurance?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Third party (third party) insurance provides third party liability coverage only, as per the terms and conditions set out in the insurance policy. Note that this insurance is mandatory according to the regulations of the Kingdom of Saudi Arabia. Comprehensive insurance provides comprehensive coverage of the insured vehicle as well as third party liability coverage. Comprehensive insurance usually covers loss or damage to insured vehicle from accidents, fire and theft, as per the terms and exceptions set forth in the insurance policy.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the residence number?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'It is the number on the Resident ID card which consists of ten digits.',
        },
      },
    ],
  };
  const arLdJsonPt3Of3 = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'الرئيسية',
        item: 'https://www.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'تأمين مركبات',
        item: 'https://www.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'تأمين طبي للشركات الصغيرة والمتوسطة',
        item: 'https://health.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'تأمين العمالة المنزلية',
        item: 'https://dh.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: 'التأمين الأخطاء الطبية',
        item: 'https://mmp.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 6,
        name: 'تأمين السفر',
        item: 'https://travel.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 7,
        name: 'فحص تاريخ المركبة (موجز)',
        item: 'https://www.tameeni.com/car/ar/Vehicle-History-Check-Mojaz',
      },
      {
        '@type': 'ListItem',
        position: 8,
        name: 'الباقة الذكية',
        item: 'https://www.tameeni.com/car/ar/Smart-Package',
      },
    ],
  };
  const enLdJsonPt3Of3 = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Motor Insurance',
        item: 'https://www.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'SME Health Insurance',
        item: 'https://health.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'Domestic Helper Insurance',
        item: 'https://dh.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: 'Medical Malpractice Insurance',
        item: 'https://mmp.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 6,
        name: 'Travel Insurance',
        item: 'https://travel.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 7,
        name: 'Vehicle History - Mojaz',
        item: 'https://www.tameeni.com/car/en/Vehicle-History-Check-Mojaz',
      },
      {
        '@type': 'ListItem',
        position: 8,
        name: 'Smart Package',
        item: 'https://www.tameeni.com/car/en/Smart-Package',
      },
    ],
  };

  return (
    <Helmet>
      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonProducts : arLdJsonProducts)}
      </script>
      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonPt1Of3 : arLdJsonPt1Of3)}
      </script>
      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonPt2Of3 : arLdJsonPt2Of3)}
      </script>
      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonPt3Of3 : arLdJsonPt3Of3)}
      </script>
    </Helmet>
  );
};

export default SEO;
